<template lang="pug">
div
  h3 修理お申し込み
  v-card
    v-card-text
      v-form(ref="form" v-model="formValid")
        v-layout(row)
          v-flex(xs8 sm9 md10 lg11)
            v-text-field(label="郵便番号"
                         required
                         :rules="zipCodeRules"
                         v-model="zipCode")
          v-flex(xs4 sm3 md2 lg1)
            v-btn(light
                  :disabled="zipCode === null || zipCode.length === 0"
                  @click="searchAddress") 住所検索

        v-text-field(label="住所1"
                     required
                     :rules="address1Rules"
                     :counter="addressMaxLength"
                     v-model="address1")

        v-text-field(label="住所2 (番地・建物名・号室)"
                     :rules="address2Rules"
                     :counter="addressMaxLength"
                     v-model="address2")

        v-text-field(label="氏名"
                     required
                     :rules="nameRules"
                     :counter="nameMaxLength"
                     v-model="name")

        v-text-field(label="電話番号"
                     required
                     :rules="telRules"
                     v-model="tel")

        v-text-field(label="製品型番"
                     required
                     :rules="productIdRules"
                     :counter="productIdMaxLength"
                     v-model="productId")

        v-text-field(label="故障内容など"
                     multi-line
                     required
                     :rules="descriptionRules"
                     :counter="descriptionMaxLength"
                     v-model="description")

        v-btn(primary dark @click="submit") 送信
  v-dialog(lazy persistent v-model="visibleCompletionDialog")
    v-card
      v-card-text 修理のお申込みを受け付けました。
      v-card-actions
        v-spacer
        v-btn.indigo--text.darken-2(flat @click="finish") OK
        v-spacer
</template>

<script>
import axios from 'axios'
import Api from '@/../app-common-vue/src/lib/Api'
import BaseComponent from '@/components/BaseComponent'

// 最大文字数
const MAX_LEN_ADDRESS = 50
const MAX_LEN_NAME = 30
const MAX_LEN_PRODUCT_ID = 50
const MAX_LEN_DESCRIPTION = 1000

// 必須項目ルール
const requiredRule = (v) => !!v || '必須項目です。'

// 文字数ルール
const lengthRule = (len) => {
  return (v) => {
    if (v === null) return true
    return v.length <= len || `${len}文字までです。`
  }
}

// 郵便番号ルール
const zipCodeRule = (v) => {
  if (v === null) return true
  let ok = (v.length === 7 && /[0-9]{7}/.test(v)) ||
           (v.length === 8 && /[0-9]{3}-[0-9]{4}/.test(v))
  return ok || '例：100-1000'
}

// 電話番号ルール
const telRule = (v) => {
  if (v === null) { return true }

  let example = '例：03-1234-5678'
  if (v.length > 13) { return example }

  let pattern = (v.indexOf('-') !== -1) ? /\d{2,5}-\d{1,4}-\d{4}/ : /\d{10,11}/
  let matched = v.match(pattern)
  if (matched && matched[0] === v) {
    return true
  } else {
    return example
  }
}

export default {
  name: 'Repair',
  extends: BaseComponent,
  props: ['initProductId'],
  computed: {
    addressMaxLength: function () {
      return MAX_LEN_ADDRESS
    },
    nameMaxLength: function () {
      return MAX_LEN_NAME
    },
    productIdMaxLength: function () {
      return MAX_LEN_PRODUCT_ID
    },
    descriptionMaxLength: function () {
      return MAX_LEN_DESCRIPTION
    }
  },
  data: function () {
    return {
      formValid: true,

      // 入力ルール
      zipCodeRules: [requiredRule, zipCodeRule],
      address1Rules: [requiredRule, lengthRule(MAX_LEN_ADDRESS)],
      address2Rules: [lengthRule(MAX_LEN_ADDRESS)],
      nameRules: [requiredRule, lengthRule(MAX_LEN_NAME)],
      productIdRules: [requiredRule, lengthRule(MAX_LEN_PRODUCT_ID)],
      telRules: [requiredRule, telRule],
      descriptionRules: [requiredRule, lengthRule(MAX_LEN_DESCRIPTION)],

      // 入力データ
      zipCode: '',
      address1: '',
      address2: '',
      name: '',
      tel: '',
      productId: '',
      description: '',

      // 完了ダイアログ
      visibleCompletionDialog: false
    }
  },
  created () {
    if (this.initProductId) {
      this.productId = this.initProductId
    }
  },
  methods: {
    searchAddress: function () {
      let search = axios.get('https://api.zipaddress.net/', {
        params: {
          'zipcode': this.zipCode
        }
      })
      search.then(res => {
        let code = res.data.code
        if (code === 200) {
          this.address1 = res.data.data.fullAddress
        } else if (code === 400) {
          alert('郵便番号の形式が正しくありません。')
        } else if (code === 404) {
          alert('住所が見つかりませんでした。')
        } else {
          alert(`エラーが発生しました。(${res.data.message})`)
        }
      })
      .catch(err => {
        alert(`エラーが発生しました。(${err})`)
      })
    },
    submit: function () {
      if (!this.$refs.form.validate()) return

      let create = new Api().createRepairRequest(this.getInputData())
      create.then(res => {
        this.visibleCompletionDialog = true
        this.$refs.form.reset()
      })
      .catch(err => {
        console.log(err)
        alert(`エラーが発生しました。(${err})`)
      })
    },
    getInputData: function () {
      return {
        'zip_code': this.zipCode,
        'address': (this.address2 ? this.address1 + this.address2 : this.address1),
        'name': this.name,
        'tel': this.tel,
        'product_id': this.productId,
        'description': this.description
      }
    },
    finish () {
      if (this.currentUser) {
        this.$router.push({ name: 'Chat' })
      } else {
        this.$router.push({ name: 'Top' })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Repair.vue?f53d81b0